import React from 'react';
import { Col, Row } from 'antd';
import signin from '../../assets/images/login.png';
import ResetPasswordForm from '../../form/entry/ResetPasswordForm';

const Reset = () => {
    return (
        <div className="contactUsContainer">
            <Row justify="center">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 6 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                >
                    <h2 className="contactUsTitle">Reset Password</h2>
                    <ResetPasswordForm />
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 9, offset: 2 }}
                    xl={{ span: 9, offset: 2 }}
                    xxl={{ span: 9, offset: 2 }}
                >
                    <div className="entry-container">
                        <img className="entry-element-container" src={signin} alt="entry" />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Reset;
